import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import './errorer.css';

function Errorer() {
  return React.createElement("div", {
    className: "errorer"
  }, React.createElement(ErrorIcon, null));
}

export default Errorer;